<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="customer !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.customer.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="customer.name"></app-form-control>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'number'" [control]="form.get('number')" [type]="'input'" [label]="t('common.labels.customer_number')" [edit]="inEdit" [basevalue]="customer.number"></app-form-control>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <h2>{{ t('common.labels.address') }}</h2>
        <app-form-control [cid]="'company'" [control]="form.get('company')" [type]="'input'" [label]="t('common.labels.company')" [edit]="inEdit" [basevalue]="customer.company"></app-form-control>
        <app-form-control [cid]="'street'" [control]="form.get('street')" [type]="'input'" [label]="t('common.labels.street')" [edit]="inEdit" [basevalue]="customer.street"></app-form-control>
        <div class="p-grid">
          <div class="p-col-2">
            <app-form-control [cid]="'zip'" [control]="form.get('zip')" [type]="'input'" [label]="t('common.labels.zip')" [edit]="inEdit" [basevalue]="customer.zip"></app-form-control>
          </div>
          <div class="p-col-6">
            <app-form-control [cid]="'city'" [control]="form.get('city')" [type]="'input'" [label]="t('common.labels.city')" [edit]="inEdit" [basevalue]="customer.city"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'country'" [control]="form.get('country')" [type]="'select'" [options]="countries" optionLabel="country_name" [dataKey]="'country_code'" [filter]="true" [showClear]="true" [label]="t('common.labels.country')" [edit]="inEdit" [basevalue]="getCountryFromCode(customer.country)"></app-form-control>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6">
        <h2>{{ t('common.labels.contact') }}</h2>
        <app-form-control [cid]="'phone'" [control]="form.get('phone')" [type]="'input'" [label]="t('common.labels.phone')" [edit]="inEdit" [basevalue]="customer.phone | phoneNumber"></app-form-control>
        <app-form-control [cid]="'email'" [control]="form.get('email')" [type]="'input'" [label]="t('common.labels.email')" [edit]="inEdit" [basevalue]="customer.email"></app-form-control>
        <app-form-control [cid]="'web'" [control]="form.get('web')" [type]="'input'" [label]="t('common.labels.web_address')" [edit]="inEdit" [basevalue]="customer.web"></app-form-control>
      </div>
    </div>

    <h2>{{ t('common.labels.additional_informations') }}</h2>
    <app-form-control [cid]="'informations'" [control]="form.get('informations')" [type]="'textarea'" [label]="t('common.labels.additional_informations')" [edit]="inEdit" [basevalue]="customer.informations"></app-form-control>

  </form>
</ng-container>
